import styled from 'styled-components';

export const PopupWrapper = styled.div`
  button {
     button {
  display: inline-flex;
  cursor: pointer;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 0.375rem !important;
  border-width: 1px !important;
  font-size: 1rem !important;
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
  padding-left: 1.75rem !important;
  padding-right: 1.75rem !important;
  font-size: 1.15rem !important;
  font-weight: 500 !important;
  color: #ffffff !important;
  box-shadow: 0 0 #000000, 0 0 #000000, 0 4px 6px -1px rgb(0, 0, 0, 0.1),
    0 2px 4px -2px rgb(0, 0, 0, 0.1) !important;

  & > div {
  font-size: 1.15rem !important;
  font-weight: 500 !important;
  }
 }
  }
`